import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Currency from '@hixme-ui/currency'
import Text from '@hixme-ui/text'

import { Button, Card } from 'components'
import { PersonBenefitPrice } from 'store/modules/persons/components'
import { EXPENSES_PATH } from '../../routes/path-names'

import CarrierInformationComponent from './CarrierInformationComponent'
import ProductCardBenefitsList from './ProductCardBenefitsList'
import ViewDetailsLink from './ViewDetailsLink'
import classes from './ProductCard.module.scss'

const ProductCard = ({
  Note,
  Persons,
  added,
  benefitsList = [],
  description,
  remainingBalance,
  handleProductOnClick = () => {},
  isProcessing,
  name,
  price,
  ignorePayrollCycle,
  priceStyle,
  label,
  productURL,
  viewOnly,
  product,
}) => {
  const PeopleCovered = () => {
    const names = Persons.map((person) => `${person.FirstName} ${person.LastName}`).join(', ')
    return (
      <Text light thin>
        People covered: <Text primary>{names}</Text>
      </Text>
    )
  }

  const RemainingBalance = () => (
    <Text light thin>
      Remaining Balance:{' '}
      <Link to={EXPENSES_PATH}>
        <Currency bold primary>
          {remainingBalance}
        </Currency>
      </Link>
    </Text>
  )

  return (
    <Card
      title={name}
      panel
      section
      className={classes.stackSpacing}
      style={{ pageBreakInside: 'avoid' }}
    >
      <div className={classes.layout}>
        <div className={classes.details}>
          {description && description.length > 0 ? (
            <p className="layout-muted-text">{description}</p>
          ) : (
            <></>
          )}
          <ProductCardBenefitsList list={benefitsList} />
          <ViewDetailsLink href={productURL} className={classes.detailsLink} />
        </div>
        <div className={classes.actions}>
          <PersonBenefitPrice
            price={price}
            label={label}
            priceStyle={priceStyle}
            ignorePayrollCycle={ignorePayrollCycle}
          />
          {!viewOnly && (
            <div className={classes.actionStack}>
              <Button
                variant="accent"
                type="button"
                block
                onClick={(e) => {
                  e.preventDefault()
                  handleProductOnClick()
                }}
                loading={isProcessing}
                loadingText={added ? 'Removing...' : 'Adding...'}
              >
                {added ? 'Added' : 'Add to benefits'}
              </Button>
              {added && <p className="layout-muted-text">(click again to remove)</p>}
            </div>
          )}
          {viewOnly && Persons && Persons.length > 0 && <PeopleCovered />}
          {viewOnly && remainingBalance !== null && <RemainingBalance />}
        </div>
      </div>
      {viewOnly && product && <CarrierInformationComponent {...product} />}
      {Note && <p className={classes.note}>{Note}</p>}
    </Card>
  )
}

ProductCard.displayName = 'ProductCard'
ProductCard.propTypes = {
  Note: PropTypes.string,
  Persons: PropTypes.array,
  added: PropTypes.bool,
  benefitsList: PropTypes.array,
  description: PropTypes.string,
  label: PropTypes.string,
  handleProductOnClick: PropTypes.func,
  isProcessing: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.number,
  remainingBalance: PropTypes.number,
  product: PropTypes.object,
  productURL: PropTypes.string,
  viewOnly: PropTypes.bool,
  ignorePayrollCycle: PropTypes.bool,
  priceStyle: PropTypes.object,
}

ProductCard.defaultProps = {
  Note: '',
  Persons: [],
  added: false,
  benefitsList: [],
  description: '',
  handleProductOnClick: null,
  isProcessing: false,
  name: '',
  label: 'per paycheck',
  price: 0,
  productURL: '',
  viewOnly: false,
  ignorePayrollCycle: false,
  remainingBalance: null,
  product: null,
  priceStyle: {},
}

export default ProductCard
